import type {LanguageCode} from './locales'
import type {OAuthProvider, Platform} from './types'

export const GOOGLE_CALENDAR_EVENTS_SCOPE = 'https://www.googleapis.com/auth/calendar.events.readonly'
export const GOOGLE_CALENDAR_LIST_SCOPE = 'https://www.googleapis.com/auth/calendar.calendarlist.readonly'
export const GOOGLE_CALENDAR_READONLY_SCOPE = 'https://www.googleapis.com/auth/calendar.readonly'
/** Supersedes the events-readonly scope at Google. */
export const GOOGLE_CALENDAR_EVENTS_WRITE_SCOPE = 'https://www.googleapis.com/auth/calendar.events'

// Short form, matching what the Microsoft adapter stores once it strips the Graph prefix.
export const MICROSOFT_CALENDARS_READ_SCOPE = 'Calendars.Read'
/** Supersedes the read scope at Microsoft. */
export const MICROSOFT_CALENDARS_WRITE_SCOPE = 'Calendars.ReadWrite'

export function parseGoogleScopes(scope: string | undefined | null): string[] {
  if (!scope) return []
  return scope.split(/\s+/).filter((part) => part.length > 0)
}

export type OAuthState = {
  platform: Platform
  provider: OAuthProvider
  languageCode: LanguageCode
  isFromWebApp: boolean
  androidRedirectUri?: string
  vanityCode?: string
  tier?: string
  period?: string
  referralCode?: string
  automatic?: boolean
}

export function getOAuthState(
  platform: Platform,
  provider: OAuthProvider,
  languageCode: LanguageCode,
  isFromWebApp: boolean,
  vanityCode?: string,
  tier?: string,
  period?: string,
  referralCode?: string
): OAuthState {
  return {
    platform,
    provider,
    languageCode,
    isFromWebApp,
    vanityCode,
    tier,
    period,
    referralCode
  }
}
